const SecurityModals = {
  LoadExtension: 'LoadExtension',
  Fetch: 'Fetch',
  OpenWindow: 'OpenWindow',
  Redirect: 'Redirect',
  RecordAudio: 'RecordAudio',
  RecordVideo: 'RecordVideo',
  ReadClipboard: 'ReadClipboard',
  Notify: 'Notify',
  Geolocate: 'Geolocate',
  Embed: 'Embed',
  Download: 'Download'
};

export default SecurityModals;
